/**
 * @file make-payment.tsx
 * @deprecated Copied to app/modules/procurement/pages/vendors_management/payments/make-payment.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/vendors_management/payments/make-payment
 * @description Page component for managing make payment in the vendors management section.
 *   Displays a list of make payment with pagination, search functionality, and CRUD operations.
 *   Allows users to view the details of make payment with warehouse context integration.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 *
 * @todo Remove debug console.log in JSX (goodsDetails, state) — use proper loading/empty states instead.
 * @todo Verify vendor.payout and vendor.bankDetails payloads match utrade-backend vendor routes.
 */

import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import ViewRequestedGoodsProducts from "../../../../modals/view-requested-goods-products";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Method from "../../../../../utils/methods";
import clsx from "clsx";
import blueCheck from "../../../../../_admin/assets/media/svg_uTrade/blue-check.svg";
import unChecked from "../../../../../_admin/assets/media/svg_uTrade/unchecked.svg";
import {
  BankPayment,
  Credit,
  PaymentToVendors,
  PermissionModule,
  Permissions,
  TigoPesaPayment,
} from "../../../../../utils/constants";
import { vendor } from "../../../../../api/apiEndPoints";
import APICallService from "../../../../../api/apiCallService";
import { useAuth } from "../../../auth";
import Loader from "../../../../../Global/loader";
import { IMAGES } from "../../../../../utils/assetsAndPermissions";
import { sellerJSON } from "../../../../../api/apiJSON/seller";
import { fileValidation } from "../../../../../Global/fileValidation";
import CloseSVG from "../../../../../_admin/assets/media/svg_uTrade/cross-rounded-gray.svg";

const MakePayment = () => {
  const { state }: any = useLocation();
  const {currentUser}=useAuth()

  const [show, setShow] = useState(false);
  const [viewProducts, setViewProducts] = useState(false);
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState<any>();
  const [password, setPassword] = useState("");
  const [valid, setValid] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [goodsDetails, setGoodDetails] = useState<any>([]);
  const [totalAmount, setTotalAmount] = useState<any>([]);
  const [paymentMethod, setPaymentMethod] = useState(BankPayment);
  const [paymentRef, setPaymentRef] = useState("");
  const [validation, setValidation] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [bankDetails, setBankDetails] = useState([]);
  const [selectedBank, setSelectedBank] = useState<any>(null);
  const [attachments, setAttachments] = useState<any[]>([]);
  const [attachmentPreviews, setAttachmentPreviews] = useState<string[]>([]);

  useEffect(() => {
    (async () => {
      setFetchLoading(true);
      await setDetails(state);
      await fetchBankDetails();
      setFetchLoading(false);
    })();
  }, []);
  useEffect(() => {
    let temp = { ...details };
    if (temp.data && temp.data.length) {
      // Use reduce to calculate the sum of stockCount by quantityType
      const sumByQuantityType = temp.data.reduce((result: any, item: any) => {
        // Check if totalQuantities exists
        if (item.totalQuantities && Array.isArray(item.totalQuantities)) {
          item.totalQuantities.forEach((quantityItem: any) => {
            const quantityType = quantityItem.quantityType;
            const stockCount = quantityItem.stockCount;
            // If the quantityType doesn't exist in the result, initialize it with stockCount, otherwise add to the existing value.
            result[quantityType] = (result[quantityType] || 0) + stockCount;
          });
        }
        return result;
      }, {});

      // Calculate total amount based on your actual data structure
      const totalAmountTemp = temp.data.reduce((sum: number, business: any) => {
        return sum + (business.charge || 0);
      }, 0);

      const sumArray = Object.keys(sumByQuantityType).map((quantityType) => ({
        quantityType: parseInt(quantityType),
        stockCount: sumByQuantityType[quantityType],
      }));

      setTotalAmount(totalAmountTemp);
      setGoodDetails(sumArray);
    }
  }, [details]);
  // all selected POs of one supplier group: pay that group, to its bank accounts (as on the PO)
  const payGroup: { name?: string; banks?: any[] } | null = (() => {
    const pos: any[] = state?.data || [];
    const g = pos[0]?.supplierGroup;
    return g?.reference && pos.every((p: any) => String(p?.supplierGroup?.reference || "") === String(g.reference)) ? g : null;
  })();
  const fetchBankDetails = async () => {
    if (payGroup?.banks?.length) {
      setBankDetails(payGroup.banks as never[]);
      return [];
    }
    let data: any = "";
    if (localStorage.getItem("profile")) {
      data = localStorage.getItem("profile");
    } else {
      localStorage.setItem("profile", details?.id);
    }
    data = state?.id;
    let apiService = new APICallService(
      vendor.bankDetails,
      data,
      "",
      "",
      "",
      "",
      PaymentToVendors
    );
    let response = await apiService.callAPI();
    if (response) {
      setBankDetails(response);
    }
    return [];
  };
  const handleMakePayment = async () => {
    if (!password.trimStart().length) {
      setValid(true);
    }
    if (paymentMethod !== Credit && !paymentRef.trimStart().length) {
      setValidation(true);
    }
    if (
      password.trimStart().length &&
      (paymentMethod === Credit || paymentRef.trimStart().length)
    ) {
      setLoading(true);
      let params: any = {
        paymentRef: paymentRef,
        password: password,
        paymentMethod: paymentMethod,
        orders: details.selectedId,
        attachments: attachments,
        bankDetails: selectedBank,
      };
      let apiService = new APICallService(
        vendor.payout,
        sellerJSON.payout(params),
        {
          id: details.id,
        },
        "",
        "",
        "",
        PaymentToVendors
      );
      let response = await apiService.callAPI();
      if (response) {
        window.history.back();
      }
      setLoading(false);
    }
  };

  return (
    <>
      <div className="p-5">
        {selectedProducts.length && viewProducts ? (
          <ViewRequestedGoodsProducts
            show={viewProducts}
            onHide={() => {
              setSelectedProducts([]);
              setViewProducts(false);
            }}
            products={selectedProducts}
          />
        ) : (
          <></>
        )}
        {fetchLoading ? (
          <>
            <Loader loading={fetchLoading} />
          </>
        ) : (
          <>
            {details && Object.keys(details).length ? (
              <>
                <>
                  <h1 className="fs-22 fw-bolder mb-7">
                    Make a payment of{" "}
                    {state.moduleKey == 1
                      ? details.data.length === 1
                        ? "order"
                        : "orders"
                      : state.moduleKey == 2
                        ? details.data.length === 1
                          ? "transfer"
                          : "transfers"
                        : details.data.length === 1
                          ? "order"
                          : "orders"}{" "}
                    to {details.name}
                  </h1>
                  <Row>
                    <Col lg={12} className="mb-4">
                      <Card className="border border-r10px bg-f9f9f9">
                        <Card.Header className="border-bottom-0 align-items-center px-7">
                          <span className="fs-22 fw-bolder">
                            {details.data.length}{" "}
                            {state.moduleKey == 1
                              ? details.data.length === 1
                                ? "Order"
                                : "Orders"
                              : state.moduleKey == 2
                                ? details.data.length === 1
                                  ? "Transfer"
                                  : "Transfers"
                                : details.data.length === 1
                                  ? "Order"
                                  : "Orders"}
                          </span>
                        </Card.Header>
                        <Card.Body className="p-0">
                          <div className="table-responsive">
                            <table className="table table-row-bordered datatable align-middle gs-7 gy-4 my-0">
                              <thead>
                                <tr className="fs-16 fw-600 border-bottom-1">
                                  <th className="min-w-100px">
                                    {state.moduleKey == 1
                                      ? "Order Date & ID"
                                      : state.moduleKey == 2
                                        ? "Transfer Date & ID"
                                        : "Order Date & ID"}
                                  </th>
                                  <th className="min-w-80px">Quantity</th>
                                  <th className="min-w-150px">Products</th>
                                  <th className="w-130px min-w-125px">
                                    Total amount
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="fs-15 fw-600">
                                {details.data.map((paymentVal: any) => {
                                  const typeTotals: Record<number, number> = {};
                                  paymentVal.variants?.forEach((v: any) =>
                                    v.quantityTypes?.forEach((qt: any) => {
                                      const t = Number(qt.type);
                                      const cnt =
                                        Number(qt.receivedStockCount) || 0;
                                      typeTotals[t] =
                                        (typeTotals[t] || 0) + cnt;
                                    })
                                  );

                                  const quantities = Object.keys(typeTotals)
                                    .map((k: string) => {
                                      const t = Number(k);
                                      return Method.formatQuantityDisplay(
                                        t,
                                        typeTotals[t]
                                      );
                                    })
                                    .filter(Boolean);
                                  return (
                                    <tr>
                                      <td>
                                        <span className="text-dark d-block">
                                          {Method.convertDateToDDMMYYYYHHMM(
                                            paymentVal._createdAt,
                                            "-"
                                          )}
                                        </span>
                                        <span className="text-gray d-block">
                                          {paymentVal.refKey}
                                        </span>
                                      </td>
                                      <td>{quantities.join(", ") || "-"}</td>
                                      <td>
                                        <div className="symbol-group symbol-hover">
                                          {paymentVal.variants.map(
                                            (val: any, idx: number) => {
                                              return idx <= 3 ? (
                                                <div className="symbol symbol-circle symbol-44px">
                                                  <img
                                                    src={
                                                      val.variant?.media?.[0]?.url
                                                    }
                                                    alt=""
                                                  />
                                                </div>
                                              ) : (
                                                <></>
                                              );
                                            }
                                          )}
                                          {paymentVal.variants.length > 4 ? (
                                            <div className="symbol symbol-circle symbol-44px">
                                              <div
                                                className="symbol-label fs-18 fw-bold bg-white text-dark"
                                                onClick={() => {
                                                  setSelectedProducts(
                                                    paymentVal.variants
                                                  );
                                                  setViewProducts(true);
                                                }}
                                              >
                                                +
                                                {paymentVal.variants.length - 4}
                                              </div>
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        {`TSh ${Method.getGeneralizedAmount(
                                          parseInt(paymentVal.charge)
                                        )}`}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <br />
                    <Col lg={12}>
                      <Card className="card-stretch bg-light border border-r10px">
                        <Card.Header className="border-bottom-0">
                          <Card.Title className="fs-22 fw-bolder">
                            Goods details
                          </Card.Title>
                        </Card.Header>
                        <Card.Body className="pt-0 pb-5 border-bottom">
                          <Row className="g-4">
                            {goodsDetails.map((val: any) => {
                              return (
                                <Col xs={12}>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <span className="fs-16 fw-600" data-testid="goods-qty">
                                      {Method.formatQuantityDisplay(val.quantityType, val.stockCount)}
                                    </span>
                                  </div>
                                </Col>
                              );
                            })}
                          </Row>
                        </Card.Body>
                        <Card.Body className="align-items-center">
                          <div className="fs-22 fw-500">
                            Total payable amount <br />
                            <span className="fw-bolder">
                              TSh {Method.getGeneralizedAmount(totalAmount)}
                            </span>
                          </div>
                        </Card.Body>
                      </Card>
                      <Card className="card-stretch bg-light border border-r10px mt-7">
                        <Card.Header className="border-bottom-0">
                          <Card.Title className="fs-22 fw-bolder">
                            Payment Mode
                          </Card.Title>
                        </Card.Header>
                        <Card.Body className="pt-0 pb-5 border-bottom">
                          <Row className="g-4">
                            <Col xs={12}>
                              <div className="d-flex justify-content align-items-center">
                                <span className="d-flex justify-content-end align-items-center">
                                  <span className="symbol symbol-circle symbol-40px me-2">
                                    <img
                                      src={
                                        paymentMethod === BankPayment
                                          ? blueCheck
                                          : unChecked
                                      }
                                      alt=""
                                      onClick={() => {
                                        setPaymentMethod(BankPayment);
                                      }}
                                    />{" "}
                                  </span>
                                </span>
                                <span className="fs-20 fw-600">
                                  Bank Transfer
                                </span>
                              </div>
                            </Col>

                            <Col xs={12}>
                              <div className="d-flex justify-content align-items-center">
                                <span className="d-flex justify-content-end align-items-center">
                                  <span className="symbol symbol-circle symbol-40px me-2">
                                    <img
                                      src={
                                        paymentMethod === TigoPesaPayment
                                          ? blueCheck
                                          : unChecked
                                      }
                                      alt=""
                                      onClick={() => {
                                        setPaymentMethod(TigoPesaPayment);
                                      }}
                                    />{" "}
                                  </span>
                                </span>
                                <span className="fs-20 fw-600">Tigo Pesa</span>
                              </div>
                            </Col>
                            {/* <Col xs={12}>
                              <div className="d-flex justify-content align-items-center">
                                <span className="d-flex justify-content-end align-items-center">
                                  <span className="symbol symbol-circle symbol-40px me-2">
                                    <img
                                      src={
                                        paymentMethod === Credit
                                          ? blueCheck
                                          : unChecked
                                      }
                                      alt=""
                                      onClick={() => {
                                        if (totalAmount < details.creditLimit) {
                                          setPaymentMethod(Credit);
                                        }
                                      }}
                                    />{" "}
                                  </span>
                                </span>
                                <span className="fs-20 fw-600">
                                  <>{console.log("details", state)}</>
                                  Credit{" "}
                                  {Method.getGeneralizedAmount(
                                    state.creditLimit
                                  )}
                                  {totalAmount > state.creditLimit
                                    ? "(Insufficient Credit Limit)"
                                    : ""}
                                </span>
                              </div>
                            </Col> */}
                          </Row>

                          {paymentMethod === BankPayment && (
                            <div className="mt-5">
                              {payGroup && (
                                <div className="notice bg-light-primary rounded border-primary border border-dashed p-3 mb-3 fs-14" data-testid="pay-group">
                                  Paying supplier group <b>{payGroup.name}</b>
                                  {payGroup.banks?.length ? ": its bank accounts are shown." : ": no group bank account, the supplier's accounts are shown."}
                                </div>
                              )}
                              <label className="fs-16 fw-600 mb-2">
                                Select Bank Account
                              </label>
                              {bankDetails.length > 0 ? (
                                <Row className="g-3">
                                  {bankDetails
                                    .filter((b: any) => b.bankName)
                                    .map((bank: any, index: number) => (
                                      <Col md={4} key={index}>
                                        <div
                                          className={clsx(
                                            "card p-4 border cursor-pointer h-100",
                                            selectedBank === bank
                                              ? "border-primary bg-light-primary"
                                              : "border-gray-300 bg-white"
                                          )}
                                          onClick={() => setSelectedBank(bank)}
                                        >
                                          <div className="d-flex align-items-center mb-2">
                                            <div
                                              className={`symbol symbol-40px me-3 ${selectedBank === bank
                                                ? "symbol-primary"
                                                : "symbol-light"
                                                }`}
                                            >
                                              <span className="symbol-label font-size-h4 font-weight-bold">
                                                {bank.bankName.substring(0, 1)}
                                              </span>
                                            </div>
                                            <div>
                                              <div className="fs-14 fw-bolder text-dark">
                                                {bank.bankName}
                                              </div>
                                              <div className="fs-12 text-gray-600">
                                                {bank.branchName}
                                              </div>
                                            </div>
                                            {selectedBank === bank && (
                                              <div className="ms-auto">
                                                <img
                                                  src={blueCheck}
                                                  alt="selected"
                                                  width={20}
                                                  height={20}
                                                />
                                              </div>
                                            )}
                                          </div>
                                          <div className="d-flex flex-column font-size-sm">
                                            <div className="d-flex justify-content-between gap-5 py-1">
                                              <span className="text-gray-600">
                                                Account No:
                                              </span>
                                              <span className="fw-bolder text-dark">
                                                {bank.accountNumber}
                                              </span>
                                            </div>
                                            {bank.identifierCode && (
                                              <div className="d-flex justify-content-between gap-5 py-1">
                                                <span className="text-gray-600">
                                                  SWIFT/IBAN:
                                                </span>
                                                <span className="fw-bolder text-dark">
                                                  {bank.identifierCode}
                                                </span>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </Col>
                                    ))}
                                </Row>
                              ) : (
                                <div className="text-muted fs-14">
                                  No bank details added for this vendor.
                                </div>
                              )}
                            </div>
                          )}
                        </Card.Body>
                        <Card.Body className="align-items-center">
                          <div className="fs-22 fw-500">
                            Enter Transaction Details <br />
                          </div>

                          <div className="mt-5">
                            <label className="fs-16 fw-600 mb-2">
                              Upload Attachments
                            </label>
                            <div className="d-flex align-items-center gap-3 flex-wrap">
                              <div
                                className="border border-dashed border-gray-300 rounded p-4 text-center cursor-pointer bg-white"
                                style={{
                                  minWidth: "100px",
                                  minHeight: "100px",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                                onClick={() =>
                                  document
                                    .getElementById("attachment-upload")
                                    ?.click()
                                }
                              >
                                <div className="fs-24 text-gray-400">+</div>
                                <div className="fs-12 fw-bold text-gray-600">
                                  Add
                                </div>
                              </div>

                              {attachmentPreviews.map((preview, index) => (
                                <div className="position-relative" key={index}>
                                  <img
                                    src={preview}
                                    alt={`Attachment Preview ${index}`}
                                    className="rounded border"
                                    style={{
                                      width: "100px",
                                      height: "100px",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <div
                                    className="position-absolute top-0 end-0 bg-white rounded-circle cursor-pointer shadow-sm d-flex align-items-center justify-content-center"
                                    style={{
                                      width: "22px",
                                      height: "22px",
                                      transform: "translate(30%, -30%)",
                                    }}
                                    onClick={() => {
                                      const newAttachments = [...attachments];
                                      newAttachments.splice(index, 1);
                                      setAttachments(newAttachments);

                                      const newPreviews = [
                                        ...attachmentPreviews,
                                      ];
                                      newPreviews.splice(index, 1);
                                      setAttachmentPreviews(newPreviews);
                                    }}
                                  >
                                    <img
                                      src={CloseSVG}
                                      alt="remove"
                                      width={10}
                                      height={10}
                                    />
                                  </div>
                                </div>
                              ))}

                              <input
                                id="attachment-upload"
                                type="file"
                                accept=".jpg, .jpeg, .png"
                                className="d-none"
                                multiple
                                onChange={(e) => {
                                  if (
                                    e.target.files &&
                                    e.target.files.length > 0
                                  ) {
                                    const newFiles = Array.from(
                                      e.target.files
                                    ).filter((file) => fileValidation(file));
                                    setAttachments([
                                      ...attachments,
                                      ...newFiles,
                                    ]);

                                    const newPreviews = newFiles.map((file) =>
                                      URL.createObjectURL(file)
                                    );
                                    setAttachmentPreviews([
                                      ...attachmentPreviews,
                                      ...newPreviews,
                                    ]);
                                  }
                                }}
                              />
                            </div>
                          </div>

                          <div className="d-block mt-4">
                            <Row className="g-3">
                              <Col md={6}>
                                {paymentMethod !== Credit && (
                                  <>
                                    <label className="fs-16 fw-600 mb-2">
                                      Payment Reference
                                    </label>
                                    <Form.Control
                                      className={clsx(
                                        "form-control-custom bg-white",
                                        validation ? "border-danger" : ""
                                      )}
                                      value={paymentRef}
                                      onChange={(event: any) => {
                                        if (!event.target.value.trimStart().length)
                                          setValidation(true);
                                        else setValidation(false);
                                        setPaymentRef(
                                          event.target.value
                                            .trimStart()
                                            .toUpperCase()
                                        );
                                      }}
                                    ></Form.Control>
                                  </>
                                )}
                              </Col>
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                      <Card className="card-stretch bg-light border border-r10px mt-7 w-50">
                        <Card.Body>
                          <span className="fs-22 fw-600">
                            Please enter your account password to mark as paid.
                          </span>
                          <InputGroup
                            className={clsx(
                              "border border-r8px mt-6",
                              !valid ? "" : "border-danger"
                            )}
                          >
                            <Form.Control
                              className="border-0 form-control-custom text-dark bg-white"
                              placeholder="Type here…"
                              type={show ? "text" : "password"}
                              value={password}
                              onChange={(event: any) => {
                                if (!event.target.value.trimStart().length) {
                                  setValid(true);
                                } else setValid(false);
                                setPassword(event.target.value.trimStart());
                              }}
                            />
                            <InputGroup.Text className="border-0">
                              <Button
                                variant="link"
                                className="btn-flush"
                                onClick={() => {
                                  setShow(!show);
                                }}
                              >
                                {show ? (
                                  <img
                                    width={25}
                                    height={16}
                                    src={IMAGES.eyeBlue}
                                    alt=""
                                  />
                                ) : (
                                  <img
                                    width={25}
                                    height={16}
                                    src={IMAGES.eyeGray}
                                    alt=""
                                  />
                                )}
                              </Button>
                            </InputGroup.Text>
                          </InputGroup>
                          {
 Method.hasPermission(PermissionModule.PaymentToVendors,Permissions.Add,currentUser)&&
                          <div className="d-block text-center mt-4">
                            <Button
                              size="lg"
                              className="uw-btn uw-btn-primary uw-btn-lg min-w-250px min-h-60px"
                              onClick={() => {
                                if (state.moduleKey === 1) {
                                  handleMakePayment();
                                }
                              }}
                            >
                              {!loading && (
                                <span className="indicator-label">
                                  Mark as paid
                                </span>
                              )}
                              {loading && (
                                <span
                                  className="indicator-progress"
                                  style={{ display: "block" }}
                                >
                                  Please wait...
                                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                              )}
                            </Button>
                          </div>
                          }
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </>
              </>
            ) : (
              <></>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default MakePayment;
